"use client";

import Grid from "@mui/material/Grid2";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import PageContainer from "@/components/atoms/PageContainer";
import PageLayout from "@/components/templates/PageLayout";
import ROUTE_URLS from "@/constants/route-urls";
import useLanguage from "@/contexts/language-context";
import { SalesDashboardMessages } from "@/messages/salesDashboard/sales-dashboard.messages";
import { BreadCrumb } from "@/types/page.types";

import AverageOrderAmountCard from "./components/AverageOrderAmountCard";
import BestsellingProductsCard from "./components/BestsellingProductsCard";
import OrderInfoCard from "./components/OrderInfoCard";
import SalesPerformanceCard from "./components/SalesPerformanceCard";
import TotalOrderAmountCard from "./components/TotalOrderAmountCard";

type Props = {
  messages: SalesDashboardMessages;
};

function SalesDashboard({ messages }: Props) {
  const { lang } = useLanguage();

  const BREAD_CRUMBS: BreadCrumb[] = [
    { title: messages.breadCrumbTitle, href: ROUTE_URLS.salesDashboard(lang) },
  ];

  return (
    <PageLayout messages={messages} title={messages.pageTitle} breadCrumbs={BREAD_CRUMBS}>
      <PageContainer>
        <MDBox mb={4}>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, lg: 4 }}>
              <OrderInfoCard messages={messages} />
            </Grid>
            <Grid size={{ xs: 12, lg: 4 }}>
              <TotalOrderAmountCard messages={messages} />
            </Grid>
            <Grid size={{ xs: 12, lg: 4 }}>
              <AverageOrderAmountCard messages={messages} />
            </Grid>
          </Grid>
        </MDBox>

        <MDBox mb={2}>
          <Grid container spacing={3} alignItems="stretch">
            <Grid size={{ xs: 12, md: 8 }}>
              <MDBox height="100%">
                <SalesPerformanceCard messages={messages} />
              </MDBox>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <MDBox height="100%">
                <BestsellingProductsCard messages={messages} />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      </PageContainer>
    </PageLayout>
  );
}

export default SalesDashboard;
